import {Injectable} from '@angular/core';
import {DeaRegistrationInformation} from './dea-registration-information.model';
import {Service} from '../../../common/service.class';
import {UserModelService} from '../../../common/user-model.service';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class DeaRegistrationInformationService extends UserModelService<DeaRegistrationInformation> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'deaRegistrationInformation', DeaRegistrationInformation);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/dea/info/dea-registration-information.service.ts